import { LiveListItem } from 'src/admin-entity/interface/live/live-list.interface';
import { Page } from 'src/admin-entity/interface/page/page-info.interface';
import { ReserveGlobalSettingsResponse } from 'src/admin-entity/interface/live/live-global-setting-reserve.interface';
import { CombinedDeliverySettings } from 'src/admin-entity/interface/live/live-combined-delivery-settings';
import { ReserveCartCancel } from 'src/admin-entity/interface/live/live-reserve-cart-cancel';
import { LsBroadcastRegisteredCoupon } from 'src/admin-entity/interface/coupon2/coupon2-ls-broadcast-setting.interface';

export enum LiveStatus {
    IDLE = 'IDLE',
    PREPARING = 'PREPARING',
    LIVE = 'LIVE',
}

export interface LiveInitType {
    searchCondition: {
        title: string;
        beginDate: string;
        endDate: string;
        searchToken: string;
        page: number;
        take: number;
    };
    liveStatus: LiveStatus;
    searchType: string;
    liveList: Page<LiveListItem>;
    currentTitle: string;
    autoAdd: boolean;
    reservationPaymentSetting: ReserveGlobalSettingsResponse;
    reservationPaymentSettingLoading: boolean;
    combinedDeliverySetting: CombinedDeliverySettings;
    combinedDeliverySettingLoading: boolean;
    reserveCartCancel: ReserveCartCancel | null;
    reserveCartCancelLoading: boolean;
    isPointUsableForSpecialPrice: boolean | null;
    isLiveRewardPointEnabled: boolean;
    liveRewardPointAmount: number;
    registeredCoupons: LsBroadcastRegisteredCoupon[];
    isLiveCouponEnabled: boolean;
}

export const initialState: LiveInitType = {
    searchCondition: {
        title: '',
        beginDate: new Date(new Date().setMonth(new Date().getMonth() - 1)).toString(),
        endDate: Date(),
        searchToken: '',
        page: 0,
        take: 10,
    },
    liveStatus: LiveStatus.IDLE,
    currentTitle: '',
    searchType: '',
    autoAdd: false,
    liveList: {
        page: {
            count: 0,
        },
        list: [],
    },
    reservationPaymentSetting: {
        isReserveCancelEnabled: false,
        maxReserveCancelCount: 5,
        isUnpaidPenaltyEnabled: false,
        maxUnpaidPenaltyCount: 5,
    },
    reservationPaymentSettingLoading: true,
    combinedDeliverySetting: {
        isBundleShippingEnabled: false,
        isUndeliverableSecondaryarea: false,
        isUndeliverableThirdarea: false,
        productShippingFee: {
            shippingFee: 0,
            primaryAreaShippingFee: 0,
            secondaryAreaShippingFee: 0,
            thirdAreaShippingFee: 0,
        },
        deliveryCompany: {
            id: 1,
            name: 'CJ대한통운',
        },
    },
    combinedDeliverySettingLoading: true,
    reserveCartCancel: null,
    reserveCartCancelLoading: false,
    isPointUsableForSpecialPrice: false,
    isLiveRewardPointEnabled: false,
    liveRewardPointAmount: 0,
    registeredCoupons: [],
    isLiveCouponEnabled: false,
};
